import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { intl } from 'lang/intl'

import { TtIcon, TtIconButton } from '@23/ui-react'

import './ActionCardAnswered.scss'

interface ActionCardAnsweredProps {
  immediate: boolean
}

const ActionCardAnswered = ({ immediate }: ActionCardAnsweredProps) => {
  const [isClosed, setIsClosed] = useState(false)

  if (isClosed) {
    return null
  }

  return (
    <div className="action-card-answered">
      <div className="check-icon-wrapper">
        <TtIcon name="check" library="one/global" />
      </div>
      <div className="message">
        {immediate ? (
          <FormattedMessage defaultMessage="Thank you for your answer." />
        ) : (
          <FormattedMessage defaultMessage="Your answer has been recorded." />
        )}
      </div>
      <TtIconButton
        className="action-card-answered-close-btn"
        label={intl.formatMessage({ defaultMessage: 'Close' })}
        library="one"
        name="close"
        onClick={() => {
          setIsClosed(true)
        }}
      />
    </div>
  )
}

export { ActionCardAnswered }
